import { render } from "./RecuperacionContrasena.vue?vue&type=template&id=5a2e5f8e&scoped=true"
import script from "./RecuperacionContrasena.vue?vue&type=script&lang=js"
export * from "./RecuperacionContrasena.vue?vue&type=script&lang=js"

import "./RecuperacionContrasena.vue?vue&type=style&index=0&id=5a2e5f8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2e5f8e"]])

export default __exports__